import { css as n } from "styled-components";
const a = {
  item: {
    wrapper: ({ variant: r = "dark", theme: o }) => /* @__PURE__ */ n([
      "width:100%;padding:0;",
      "{padding:0 ",
      ";}color:",
      ";"
    ], o.breakpoints.mq && o.breakpoints.mq.tabletMin, o.space.xs, r === "light" ? o.componentColors.accordion.itemWrapper : void 0),
    button: ({ variant: r = "dark", theme: o }) => /* @__PURE__ */ n([
      "display:flex;position:relative;align-items:start;box-sizing:border-box;width:100%;border:none;background:none;padding:",
      ";padding-left:0;margin-bottom:",
      ";text-align:left;",
      "{padding-left:",
      ";}",
      " ",
      " ",
      ""
    ], o.space.xs, o.space.xs, o.breakpoints.mq && o.breakpoints.mq.tabletMin, o.space.xs, o.components.link.base, o.components.link.medium, o.components.link[r]),
    iconWrapper: ({ isOpen: r, theme: { breakpoints: o } }) => /* @__PURE__ */ n([
      "margin-right:1.4rem;margin-top:-0.1rem;",
      "{margin-top:-0.2rem;}svg{fill:currentColor;width:1rem;height:1rem;transition:transform 0.2s ease-in-out;transform:rotate(",
      ");@media (prefers-reduced-motion){transition:none;}}"
    ], o.mq && o.mq.tabletMin, r ? "90deg" : "0deg"),
    contentWrapper: ({ theme: r }) => /* @__PURE__ */ n([
      "padding:0 ",
      " 0 ",
      ";",
      "{padding-left:",
      ";}overflow:hidden;"
    ], r.space.xs, r.space.md, r.breakpoints.mq.tabletMin, r.space.lg)
  },
  wrapper: {
    base: ({ theme: r, variant: o }) => /* @__PURE__ */ n([
      "width:100%;> div{padding-top:",
      ";border-bottom:0.3rem solid ",
      ";}"
    ], r.space.xs, o ? r.componentColors.accordion.wrapper[o] : r.componentColors.accordion.wrapper.dark)
  }
};
export {
  a as default
};
